import clsx from 'clsx';
import { FC, ReactNode } from 'react';

interface Props {
  title: string;
  className?: string;
  children: ReactNode;
}

export const Section: FC<Props> = ({ title, className, children }) => (
  <div
    className={clsx(
      'flex flex-col gap-5 border-b border-solid border-lightGray px-1 pt-7 pb-6 first:border-t md:grid md:grid-cols-6 md:gap-5 md:px-5 md:pt-8 md:pb-5',
      className,
    )}
  >
    <div className="md:col-span-1">
      <p className="font-bold">{title}</p>
    </div>
    <div className="text-sm md:col-span-5">{children}</div>
  </div>
);
